'use client';

import { MainButton } from '../atomic-atoms';

interface ErrorUIProps {
  title?: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
  hideAction?: boolean;
}

export function ErrorUI({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
  actionLabel = 'Retry',
  onAction,
  hideAction = false,
}: ErrorUIProps) {
  return (
    <div
      style={{
        border: '1px solid var(--nn-accent-red)',
        backgroundColor: 'var(--nn-error-background-color)',
        color: 'var(--nn-accent-red)',
        padding: 'var(--outer-border-radius)',
        borderRadius: '12px',
        maxWidth: '480px',
        maxHeight: '350px',
        overflowY: 'auto',
        margin: '40px auto',
        fontFamily: 'system-ui, sans-serif',
      }}
    >
      <h2
        style={{
          fontSize: '1.5rem',
          fontWeight: 700,
          marginBottom: '0.5rem',
          textAlign: 'center',
        }}
      >
        {title}
      </h2>

      <p
        style={{
          marginBottom: '16px',
          lineHeight: '1.5',
        }}
      >
        {message}
      </p>

      {!hideAction && onAction && (
        <MainButton onClick={onAction} ariaLabel={actionLabel} variant="error">
          {actionLabel}
        </MainButton>
      )}
    </div>
  );
}
